// extracted by mini-css-extract-plugin
export var shake = "_y-0";